import { useEffect, useState, type FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { api, ApiError } from '../lib/api';
import { PoweredBy, Wordmark } from '../lib/Brand';
import { setAppTitle } from '../lib/format';

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => setAppTitle('Log in'), []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(email, password);
      const from = (location.state as { from?: string } | null)?.from;
      navigate(from && /^\/(admin|platform-admin)(\/|$)/.test(from) ? from : '/admin', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Something went wrong.');
      setBusy(false);
    }
  }

  return (
    <main className="page narrow login">
      <div className="login-head">
        <h1 className="visually-hidden">Seller log in</h1>
        <Wordmark className="wordmark" />
        <p className="muted">Log in to manage your sale.</p>
      </div>
      <form onSubmit={submit} className="stack card">
        <label className="field">
          <span>Email</span>
          <input type="email" autoComplete="username" inputMode="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="field">
          <span>Password</span>
          <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <p className="error" role="alert">{error}</p>}
        <button className="btn primary big" disabled={busy}>
          {busy ? 'Logging in…' : 'Log in'}
        </button>
      </form>
      <PoweredBy />
    </main>
  );
}
